"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var NoDataPlaceholder_meta_1 = require("../NoDataPlaceholder.meta");

var InjectedStyledComponent_1 = require("../../../../shared/InjectedStyledComponent");

exports.default = InjectedStyledComponent_1.InjectedStyledComponent('section', NoDataPlaceholder_meta_1.NO_DATA_PLACEHOLDER_CATEGORY_KEY, NoDataPlaceholder_meta_1.NO_DATA_PLACEHOLDER_COMPONENT_KEY, ['wrapper']);